'use strict';

var _create = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/create"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function inherits(ctor, superCtor) {
  ctor.prototype = (0, _create["default"])(superCtor.prototype, {
    constructor: {
      value: ctor,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
}

module.exports = inherits;